import React from 'react';
import './GoogleLibUnavailable.css'

const GoogleLibUnavailable = () => {
    return (
        <div className="slc-google-lib-unavailable">
            Questa applicazione necessita di una connessione internet attiva.<br />
            Controllare la propria connessione internet.
        </div>
    );
};

export default GoogleLibUnavailable;